import React, { Component } from "react";
import { Redirect } from 'react-router';
import { Link, Route , withRouter} from 'react-router-dom';
import Header from './Header';
import Menu from './Menu';
import '../assets/css/thank-you.css';
import { QUESTION } from "../services/Questions";
import {CONFIG, URLS,encryptPHI,decryptPHI, getLoggedInData} from '../helpers/Common';
import IdleTimer from 'react-idle-timer'
import Loader from './Loader';
import { SURGEON } from "../services/Surgeon";


class Thankyou extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            patientData:'',
            redirect: false,
            surgeon_id: '',
            isLoading : false,
            clinic_id:'',
        };
        // this.savePatientNarratives  = this.savePatientNarratives.bind(this);
        this.idleTimer = null
        this.onIdle = this._onIdle.bind(this)
        // this.redirectToHome         = this.redirectToHome.bind(this);
        
    }

    // componentWillMount()
    // {
    //     //const patientData = localStorage.getItem('data');
    //     const patientData = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("data"));
       
    //     //const allComplains= localStorage.getItem("allComplains");
    //     const allComplains = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("allComplains"));
      
    //     //const oldData = localStorage.getItem("oldData");
    //     const oldData = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("oldData"));
       

    //     if(!patientData)
    //     {   
    //         this.props.history.push('/');
    //     }

    //     this.setState({
    //         patientData:JSON.parse(patientData),
    //         allComplains: JSON.parse(allComplains),
    //         oldData:JSON.parse(oldData)
    //     })
        
    //     let userData = getLoggedInData();

    //     this.setState({
    //         surgeon_id: userData.user_id,
    //         clinic_id: userData.clinic_id,
    //     })

    //     setTimeout(()=>{

    //         this.savePatientNarratives(true)

    //     },1000);
    //     // this.savePatientNarratives(true);
       
    // }
    
    _onIdle(e) {
        // console.log('user is idle', e)
        // console.log('last active', this.idleTimer.getLastActiveTime())
        localStorage.removeItem('data');
        localStorage.removeItem('patientProfile');
        this.setState({redirect: true});
    }

    componentDidMount() {
        //Clear local storage on close
        window.addEventListener("beforeunload", (ev) => {
            ev.preventDefault();
            localStorage.removeItem('data');
            localStorage.removeItem('patientProfile');
            this.setState({redirect: true});
        });
    }


    // savePatientNarratives = (isExport)=>
    // {

    //     this.setState({
    //         isLoading : false,
    //     });
        
    //     let data = this.state.patientData;
    //     let title = encryptPHI(CONFIG.ENCRYPTION_KEY,data.title);
    //     let first_name = encryptPHI(CONFIG.ENCRYPTION_KEY,data.first_name);
    //     let last_name = encryptPHI(CONFIG.ENCRYPTION_KEY,data.last_name);
    //     let email = encryptPHI(CONFIG.ENCRYPTION_KEY,data.email);
    //     let phone = encryptPHI(CONFIG.ENCRYPTION_KEY,data.phone);
    //     let gender = encryptPHI(CONFIG.ENCRYPTION_KEY,data.gender);
    //     let narrative_summary = encryptPHI(CONFIG.ENCRYPTION_KEY,data.narrative_summary);
    //     let dob = encryptPHI(CONFIG.ENCRYPTION_KEY,data.dob);
    //     let patient_additional_info = encryptPHI(CONFIG.ENCRYPTION_KEY,data.patient_additional_info);
    //     //let allComplains = encryptPHI(CONFIG.ENCRYPTION_KEY,this.state.allComplains);
    //     let allComplains = this.state.allComplains;
    //     for (let index = 0; index < allComplains.length; index++) {
            
    //         allComplains[index].profileSummary = encryptPHI(CONFIG.ENCRYPTION_KEY,allComplains[index].profileSummary);

    //     }
    //    // allComplains[0].profileSummary = encryptPHI(CONFIG.ENCRYPTION_KEY,allComplains[0].profileSummary);

    //     data.title          = title;
    //     data.first_name     = first_name;
    //     data.last_name      = last_name;
    //     data.email          = email;
    //     data.phone          = phone;
    //     data.gender         = gender;
    //     data.narrative_summary =narrative_summary;
    //     data.dob = dob; 
    //     data.patient_additional_info = patient_additional_info;
       
    //     data.isExport   = isExport;
    //     data.surgeon_id=this.state.surgeon_id;
    //     data.clinic_id=this.state.clinic_id;
    //     data.allComplains=this.state.allComplains;
    //     data.newData = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("newData"));
    //     data.data=this.state.oldData;
        
    //     QUESTION.savePatientNarratives(data).then(res => {
    //         if(res.data.header.error==0)
    //         {
    //             localStorage.removeItem('data');
    //             localStorage.removeItem('patientProfile');
    //             // this.setState({redirect: true});
    //         }
    //         else
    //         {
    //             alert('something went wrong! please submit complain again');
    //             // this.setState({redirect: true});
    //         }
            
    //     }).catch(err => {
    //         alert("There was an error! please submit complain again ");
    //         // this.setState({redirect: true});
    //     });
       
    // }

     redirectHome=()=>{
        this.setState({redirect: true});
         
        let userData = JSON.parse(localStorage.getItem("LoginUserData"));
        if(userData.email == 'guest@neurodiagnostics.io' || userData.email == 'guest@neuro-diagnostics.com'){
            if (userData) {
                let LogoutResponse = SURGEON.logout(userData)
                .then(res => {
                
                if (res.data.header.error == 0) {
                   
                    localStorage.removeItem('LoginUserData');
                    window.location.replace(window.location.pathname+'#/surgeon/login/');
                    return;
                    
                } else {
                    alert('Something went wrong please try again later');
                    localStorage.removeItem('LoginUserData');
                    window.location.replace(window.location.pathname+'#/surgeon/login/');
                    return;
                    // console.log(res);
                }
                })
                .catch(err => {
                return err;
                });
            }
            
        }
    };

    render() {
    if (this.state.redirect) {
        return <Redirect push to="/" />;
    }
    return (
        <React.Fragment>
            {/* <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            element={document}
            onIdle={this.onIdle}
            debounce={250}
            timeout={1000 * 60 * CONFIG.IdleTimeOut} /> */}
            <Header title="Narrative Accepted" titleImage="ic-medical-result.png" />
            <Menu />
            <div className="thank-you-bg">
            <section className="thank-you">
                <div className="txt-content">
                    <div className="container">
                        <img src={require("../assets/img/icons/ic-check.png")} alt="" />
                        <h2>Thank you for sharing a detailed history of your symptoms. This information will be shared with the Physician for diagnosis. </h2>
                        <p>We would be really grateful if you can share your feedback about this platform and what you would like us to improve by clicking on <a href="https://docs.google.com/forms/d/e/1FAIpQLSeo18KXEDRHAosVJhKrqJ0jl9Dq9jBwap11D4T7EKdYOj3VUg/viewform?usp=sf_link" target="_blank">this link</a>. </p>
                    </div>
                </div>
            </section>

                <div className="sec-btn thank--btn">
                    <div className="loading-spiner" style={{visibility: this.state.isLoading ? 'visible' : 'hidden' }}>
                        <div style={{display: 'flex', justifyContent: 'center',position: 'absolute',left: '50%',top: '50%',transform: 'translate(-50%, -50%)'}}>
                            <Loader/>
                        </div>
                    </div>
                    <Link to="#" onClick={() => this.redirectHome()} className="btn-img" style={{visibility: !this.state.isLoading ? 'visible' : 'hidden'}}>
                        <img src={require("../assets/img/icons/ic-close.png")} alt="" />
                        <span>Return to staff</span>
                    </Link>
                    {/* <Link to="#" onClick={() => this.redirectHome()} className="btn-img" style={{visibility: !this.state.isLoading ? 'visible' : 'hidden' }}>
                        <img src={require("../assets/img/icons/ic-export.png")} alt="" />
                        <span>Send me a<br />Copy</span>
                    </Link> */}
                </div>
            </div>
        </React.Fragment>
    );
  }
}

export default Thankyou;

